export const filtersList = [
  {
    name: {
      en: 'Online payment',
      ru: 'Онлайн оплата',
      ro: 'Plata online',
    },
    label: 'card_payment',
  },
  {
    name: {
      en: 'Promo',
      ru: 'Акции',
      ro: 'Stoc',
    },
    label: 'promo',
  },
  {
    name: {
      en: 'Discount',
      ru: 'Скидки',
      ro: 'Reduceri',
    },
    label: 'discount',
  },
  {
    name: {
      en: 'Free delivery',
      ru: 'Бесплатная доставка',
      ro: 'Livrare gratuita',
    },
    label: 'delivery',
  },
  {
    name: {
      en: 'Recommended',
      ru: 'Рекомендуем',
      ro: 'Recomandat',
    },
    label: 'top',
  },
  {
    name: {
      en: 'News of the week',
      ru: 'Новинки недели',
      ro: 'Știrile săptămânii',
    },
    label: 'new',
  },
];

export const sortingList = [
  {
    name: {
      en: 'By default',
      ru: 'По умолчанию',
      ro: 'Implicit',
    },
    label: 'default',
  },
  {
    name: {
      en: 'By rating',
      ru: 'По рейтингу',
      ro: 'Recenzii',
    },
    label: '-rate',
  },
  {
    name: {
      en: 'Fast',
      ru: 'Быстрые',
      ro: 'Rapid',
    },
    label: 'avg_delivery_time',
  },
  {
    name: {
      en: 'By price',
      ru: 'Дешёвые',
      ro: 'Ieftin',
    },
    label: 'price_level',
  },
  {
    name: {
      en: 'Expensive',
      ru: 'Дорогие',
      ro: 'Scump',
    },
    label: '-price_level',
  },
];
